export default "__VITE_ASSET__PXZKfHZW__"